export default __webpack_public_path__ + "static/media/OpenSans.6b93a839.woff";